export default "__VITE_ASSET__BJGA_ykh__"